import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetUpcomingReadyJobsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionJobDocumentSortInput> | Types.ProductionJobDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetUpcomingReadyJobsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', nodes?: Array<{ __typename?: 'ProductionJobDocument', id: string, jobNumber: number, productionPlanName: string, categoryName: string, quantity: number, eaches: number, unitLabel: string, weekReadyDate: Types.TDateISO, weekReadyIsoWeek: number, weekReadyIsoYear: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type UpcomingReadyJobFragment = { __typename?: 'ProductionJobDocument', id: string, jobNumber: number, productionPlanName: string, categoryName: string, quantity: number, eaches: number, unitLabel: string, weekReadyDate: Types.TDateISO, weekReadyIsoWeek: number, weekReadyIsoYear: number };

export const UpcomingReadyJobFragmentDoc = new TypedDocumentString(`
    fragment UpcomingReadyJob on ProductionJobDocument {
  id
  jobNumber
  productionPlanName
  categoryName
  quantity
  eaches
  unitLabel
  weekReadyDate
  weekReadyIsoWeek
  weekReadyIsoYear
}
    `, {"fragmentName":"UpcomingReadyJob"});
export const GetUpcomingReadyJobsDocument = new TypedDocumentString(`
    query GetUpcomingReadyJobs($where: ProductionJobDocumentFilterInput, $order: [ProductionJobDocumentSortInput!], $first: Int) {
  productionJobs(where: $where, order: $order, first: $first) {
    nodes {
      ...UpcomingReadyJob
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment UpcomingReadyJob on ProductionJobDocument {
  id
  jobNumber
  productionPlanName
  categoryName
  quantity
  eaches
  unitLabel
  weekReadyDate
  weekReadyIsoWeek
  weekReadyIsoYear
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetUpcomingReadyJobs: build.query<GetUpcomingReadyJobsQuery, GetUpcomingReadyJobsQueryVariables | void>({
      query: (variables) => ({ document: GetUpcomingReadyJobsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetUpcomingReadyJobsQuery, useLazyGetUpcomingReadyJobsQuery } = injectedRtkApi;
